import router from './router'
import store from './store'
import {getLocalStorage,setLocalStorage,setToken} from '@/utils/auth'
// import NProgress from 'nprogress' // Progress 进度条
// import 'nprogress/nprogress.css'// Progress 进度条样式
// import { Message } from 'element-ui'
// import { getToken,removeToken,getUserType,getCode,removeCode } from '@/utils/auth' // 验权

// const whiteList = ['/login'] // 不重定向白名单
// router.beforeEach((to, from, next) => {
//   NProgress.start()
//   if (getToken()) {
//     	if(to.path!='/login'){
//     	next({ path: '/login' })
//       NProgress.done()
//       removeCode()
//       removeToken()
//     	}
// 			else {
//         next()
//      }
//   } else {
//     if (whiteList.indexOf(to.path) !== -1) {
//       next()
//     } else {
//       next('/login')
//       removeCode()
//       removeToken()
//       NProgress.done()
//     }
//   }
// })

// router.afterEach(() => {
//   NProgress.done() // 结束Progress
// })

router.beforeEach((to,from,next)=>{
	let userInfo = getLocalStorage()
	console.log(userInfo)
	console.log(to)//去哪里
	console.log(from)//从哪来
	console.log(router)
	
	console.log(store)
	
	if(userInfo){
		store.state.user.userInfo = userInfo
	}
	
	store.state.user.path = to.path
	console.log(store.state.user.path)
	
	// store.state.path = to.path
	if(!userInfo&&to.path!='/login'){
		next({ path: '/login' })
	}else if(userInfo&&to.path=='/login'){
		next({ path: '/' })
	}else {
		next()
	}
})



// WEBPACK FOOTER //
// ./src/permission.js